import { lazy } from "react"

export const AnalyticsDeliveriesPickupsPage = lazy(() => import("./AnalyticsDeliveriesPickupsPage"))